const state = () => ({
  offsetY: 0,
  deviceWidth: 0,
  scrolled: false,
})
export default state

export type LayoutState = ReturnType<typeof state>
